<div
  class="social"
  *ngIf="agencyService.agency.facebook_link || agencyService.agency.gplus_link || agencyService.agency.instagram_link
  || agencyService.agency.pinterest_link || agencyService.agency.youtube_link"
  fxLayout="row"
  fxLayoutAlign="center center"
>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="social-icons"
  >
    <a
      target="_blank"
      *ngIf="agencyService.agency.facebook_link"
      [href]="agencyService.agency.facebook_link"
      [matTooltip]="agencyService.agency.facebook_link"
      [matTooltipPosition]="isTooltipBelow ? 'below' : 'above'"
      appGtagEvent
      eventCategory="social_media"
      eventAction="click"
      eventLabel="facebook_click"
      appFbqEvent="social_media"
      [customData]="{content_name: 'facebook_click', content_category: 'click'}"
    >
      <div
        class="icon-container facebook-icon"
      >
      </div>
    </a>
    <a
      target="_blank"
      *ngIf="agencyService.agency.gplus_link"
      [href]="agencyService.agency.gplus_link"
      [matTooltip]="agencyService.agency.gplus_link"
      [matTooltipPosition]="isTooltipBelow ? 'below' : 'above'"
      appGtagEvent
      eventCategory="social_media"
      eventAction="click"
      eventLabel="gplus_click"
      appFbqEvent="social_media"
      [customData]="{content_name: 'gplus_click', content_category: 'click'}"
    >
      <div
        class="icon-container google-icon"
      >
      </div>
    </a>
    <a
      target="_blank"
      *ngIf="agencyService.agency.instagram_link"
      [href]="agencyService.agency.instagram_link"
      [matTooltip]="agencyService.agency.instagram_link"
      [matTooltipPosition]="isTooltipBelow ? 'below' : 'above'"
      appGtagEvent
      eventCategory="social_media"
      eventAction="click"
      eventLabel="instagram_click"
      appFbqEvent="social_media"
      [customData]="{content_name: 'instagram_click', content_category: 'click'}"
    >
      <div
        class="icon-container instagram-icon"
      >
      </div>
    </a>
    <a
      target="_blank"
      *ngIf="agencyService.agency.pinterest_link"
      [href]="agencyService.agency.pinterest_link"
      [matTooltip]="agencyService.agency.pinterest_link"
      [matTooltipPosition]="isTooltipBelow ? 'below' : 'above'"
      appGtagEvent
      eventCategory="social_media"
      eventAction="click"
      eventLabel="pinterest_click"
      appFbqEvent="social_media"
      [customData]="{content_name: 'pinterest_click', content_category: 'click'}"
    >
      <div
        class="icon-container pinterest-icon"
      >
      </div>
    </a>
    <a
      target="_blank"
      *ngIf="agencyService.agency.youtube_link"
      [href]="agencyService.agency.youtube_link"
      [matTooltip]="agencyService.agency.youtube_link"
      [matTooltipPosition]="isTooltipBelow ? 'below' : 'above'"
      appGtagEvent
      eventCategory="social_media"
      eventAction="click"
      eventLabel="youtube_click"
      appFbqEvent="social_media"
      [customData]="{content_name: 'youtube_click', content_category: 'click'}"
    >
      <div
        class="icon-container youtube-icon"
      >
      </div>
    </a>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/social-icons-base/social-icons-base.component.html